(function () {
  'use strict';

  function initVideoGallery(root) {
    if (!root || root.getAttribute('data-vg-init') === '1') return;
    root.setAttribute('data-vg-init', '1');

    var instanceId = root.getAttribute('data-instance-id') || '';
    if (!instanceId) return;

  var API_URL = root.getAttribute('data-api-url') || '';
  var DISPLAY_LOCATION = root.getAttribute('data-display-location') || '';
  var LIMIT = parseInt(root.getAttribute('data-video-limit') || '55', 10);
  if (isNaN(LIMIT) || LIMIT < 0) LIMIT = 55;
  var MAPPED_HANDLE = root.getAttribute('data-mapped-handle') || '';
  var LIQUID_PRODUCT = {
    title: root.getAttribute('data-mapped-title') || '',
    url: root.getAttribute('data-mapped-url') || '',
    image: root.getAttribute('data-mapped-image') || '',
    priceCents: root.getAttribute('data-mapped-price') || ''
  };
  var VG_LBL = {
    view: root.getAttribute('data-lbl-view') || 'View details',
    atc: root.getAttribute('data-lbl-atc') || 'Add to cart'
  };
  var FORCE_PRODUCT_HANDLE = root.getAttribute('data-force-product-handle') || '';

  var PERF = window.WOMPerf || { mark: function () {}, span: function () { return function () {}; } };
  var PRIORITY = window.WOMPriority;
  var PRIORITY_KEY = 'video-gallery';
  if (PRIORITY && PRIORITY.expect) PRIORITY.expect(PRIORITY_KEY);

  function markPriorityDone() {
    if (PRIORITY && PRIORITY.markDone) PRIORITY.markDone(PRIORITY_KEY);
  }

  var modal = document.getElementById('video-gallery-modal-' + instanceId);
  var feed = modal ? modal.querySelector('[data-vg-feed]') : null;
  var reelShell = modal ? modal.querySelector('.vg-modal-mode--mobile') : null;
  var desktopShell = modal ? modal.querySelector('.vg-modal-mode--desktop') : null;
  var closeBtns = modal ? modal.querySelectorAll('.video-gallery-modal-close') : [];
  var overlay = modal ? modal.querySelector('.video-gallery-modal-overlay') : null;
  var modalVideo = document.getElementById('video-gallery-modal-player-' + instanceId);
  var shellStillImg = modal ? modal.querySelector('[data-vg-shell-still]') : null;
  var shellStillVideo = modal ? modal.querySelector('[data-vg-shell-still-video]') : null;
  var prevBtn = modal ? modal.querySelector('[data-vg-prev]') : null;
  var nextBtn = modal ? modal.querySelector('[data-vg-next]') : null;
  var muteBtn = modal ? modal.querySelector('[data-vg-mute]') : null;
  var shareBtnModal = modal ? modal.querySelector('[data-vg-share]') : null;
  var titleEl = modal ? modal.querySelector('[data-vg-title]') : null;
  var modalImageWrap = modal ? modal.querySelector('[data-vg-image-wrap]') : null;
  var modalImage = modal ? modal.querySelector('[data-vg-image]') : null;
  var modalPrices = modal ? modal.querySelector('[data-vg-prices]') : null;
  var modalAdd = modal ? modal.querySelector('[data-vg-add]') : null;
  var modalLink = modal ? modal.querySelector('[data-vg-link]') : null;
  var modalRatingEl = modal ? modal.querySelector('[data-wom-video-rating]') : null;
  var pageScrollLockY = 0;
  var pageScrollLocked = false;

  function lockPageScroll() {
    if (pageScrollLocked) return;
    pageScrollLocked = true;
    pageScrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + pageScrollLockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockPageScroll() {
    if (!pageScrollLocked) return;
    pageScrollLocked = false;
    var y = pageScrollLockY;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, y);
  }

  function snapFeedToIndex(index, smooth) {
    if (!feed) return;
    var slide = feed.querySelector('[data-slide-index="' + String(index) + '"]');
    var top = 0;
    if (slide) {
      top = Math.max(0, slide.offsetTop);
    } else if (feed.clientHeight) {
      top = Math.max(0, index * feed.clientHeight);
    }
    feed.classList.add('vg-feed--instant');
    try {
      if (smooth && typeof feed.scrollTo === 'function') {
        feed.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        feed.scrollTop = top;
      }
      void feed.offsetHeight;
    } finally {
      feed.classList.remove('vg-feed--instant');
    }
  }

  function focusFeedSlide(slideEl, smooth) {
    if (!feed || !slideEl) return;
    var idx = parseInt(slideEl.getAttribute('data-slide-index') || '0', 10);
    if (isNaN(idx)) idx = 0;
    snapFeedToIndex(idx, !!smooth);
  }

  function mountVideoRating(el, handle) {
    if (window.WomVideoProductRating && el) {
      window.WomVideoProductRating.mount(el, handle);
    } else if (el) {
      el.innerHTML = '';
      el.hidden = true;
    }
  }

  var DESKTOP_BP = 990;
  var playlist = [];
  var lastWomApiData = null;
  var collectionCatalog = [];
  var videoHandleIndex = {};
  var catalogReady = null;
  var CATALOG_HANDLE = root.getAttribute('data-catalog-collection') || '';
  if (!CATALOG_HANDLE && (DISPLAY_LOCATION === 'homepage' || DISPLAY_LOCATION === '')) {
    CATALOG_HANDLE = 'shop-all';
  }
  // First-frame stills captured from rail preview videos (blob URLs).
  var posterCache = {};
  var galleryThumbPreloaded = {};

  function preloadGalleryThumbUrls(list, maxCount) {
    if (!list || !list.length) return;
    var end = typeof maxCount === 'number' ? Math.min(list.length, maxCount) : list.length;
    for (var pi = 0; pi < end; pi++) {
      var entry = list[pi];
      var u = entry && entry.s3_url;
      if (!u) continue;
      var thumb = entry.poster || posterCache[u] || '';
      if (!thumb && window.WOMVideoPoster && window.WOMVideoPoster.thumbFromVideoUrl) {
        thumb = window.WOMVideoPoster.thumbFromVideoUrl(u) || '';
      }
      if (!thumb) continue;
      posterCache[u] = thumb;
      if (galleryThumbPreloaded[thumb]) continue;
      galleryThumbPreloaded[thumb] = true;
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = thumb;
    }
  }
  // When stories (or another rail) opens this modal, modalPlaylist overrides
  // the card rail playlist for desktop/mobile player only — rail stays intact.
  var modalPlaylist = null;

  function getModalList() {
    return modalPlaylist || playlist;
  }
  var renderedCount = 0;
  /* Client rail plan: 10 DOM cards; MP4 in batches of 5; scroll expands to 15 / 20 */
  var INITIAL_PAGE_DESKTOP = 10;
  var INITIAL_PAGE_MOBILE = 10;
  var APPEND_PAGE_DESKTOP = 10;
  var APPEND_PAGE_MOBILE = 5;
  var RAIL_MP4_BATCH = 5;
  var RAIL_INITIAL_DOM = 10;
  var RAIL_SCROLL_AT_5 = 4;
  var RAIL_EXPAND_TO_15 = 15;
  var RAIL_SCROLL_AT_10 = 9;
  var RAIL_EXPAND_TO_20 = 20;
  var mp4BatchTier = 0;
  var PHONE_AHEAD = 1;
  var PHONE_BATCH_LEAD = 2;
  var railLazyApi = null;
  var appendingPage = false;
  var modalIndex = 0;
  var prefersMuted = false;
  var modalAudioUnlocked = false;
  var suppressSlideObserverUntil = 0;
  var mappedProduct = null;
  var feedBuilt = false;
  var slideObserver = null;

  function isDesktopModal() {
    return window.matchMedia('(min-width: ' + DESKTOP_BP + 'px)').matches;
  }

  function getInitialPage() {
    return isDesktopModal() ? INITIAL_PAGE_DESKTOP : INITIAL_PAGE_MOBILE;
  }

  function getAppendPage() {
    return isDesktopModal() ? APPEND_PAGE_DESKTOP : APPEND_PAGE_MOBILE;
  }

  function getPrefetchCards() {
    return isDesktopModal() ? 4 : PHONE_BATCH_LEAD;
  }

  function getMp4LoadCap(activeIdx) {
    if (isDesktopModal()) return 999999;
    var cap = RAIL_MP4_BATCH - 1;
    if (mp4BatchTier >= 1) cap = Math.min(RAIL_INITIAL_DOM - 1, Math.max(0, renderedCount - 1));
    if (mp4BatchTier >= 2) cap = Math.max(cap, Math.max(0, renderedCount - 1));
    var idx = typeof activeIdx === 'number' && !isNaN(activeIdx) ? activeIdx : 0;
    if (idx >= RAIL_SCROLL_AT_10) {
      cap = Math.max(cap, Math.min(RAIL_EXPAND_TO_20 - 1, Math.max(0, renderedCount - 1)));
    } else if (idx >= RAIL_SCROLL_AT_5) {
      cap = Math.max(cap, Math.min(RAIL_EXPAND_TO_15 - 1, idx + RAIL_MP4_BATCH));
    }
    return Math.min(cap, Math.max(0, renderedCount - 1));
  }

  function galleryVideoAt(index) {
    var card = root.querySelector('.vg-card-outer[data-vg-index="' + index + '"]');
    return card ? card.querySelector('video[data-lazy-video]') : null;
  }

  function maybeUnlockMp4Batch() {
    if (isDesktopModal() || mp4BatchTier >= 2) return;
    var batchStart = mp4BatchTier === 0 ? 0 : RAIL_MP4_BATCH;
    var batchEnd = mp4BatchTier === 0 ? RAIL_MP4_BATCH : RAIL_INITIAL_DOM;
    var allReady = true;
    var anyMounted = false;
    for (var bi = batchStart; bi < batchEnd && bi < renderedCount; bi++) {
      var v = galleryVideoAt(bi);
      if (!v) {
        allReady = false;
        continue;
      }
      if (v.dataset.mounted !== '1') {
        allReady = false;
        break;
      }
      anyMounted = true;
      if (v.readyState < 2 && !v.error) {
        allReady = false;
        break;
      }
    }
    if (allReady && anyMounted) {
      mp4BatchTier += 1;
      if (railLazyApi && railLazyApi.refresh) railLazyApi.refresh();
      if (mp4BatchTier < 2) window.setTimeout(maybeUnlockMp4Batch, 80);
    }
  }

  function maybeExpandRailFromScroll(activeIdx) {
    if (isDesktopModal()) return;
    var target = null;
    if (activeIdx >= RAIL_SCROLL_AT_10) {
      target = Math.min(RAIL_EXPAND_TO_20, playlist.length);
    } else if (activeIdx >= RAIL_SCROLL_AT_5) {
      target = Math.min(RAIL_EXPAND_TO_15, playlist.length);
    }
    if (target != null && renderedCount < target) {
      ensureCardsThrough(target);
    }
  }

  function mayLoadMp4At(index, activeIdx) {
    return index <= getMp4LoadCap(activeIdx);
  }

  function updateGridAlignment(count) {
    if (count > 0 && count < 5) {
      root.classList.add('video-gallery-grid--few');
    } else {
      root.classList.remove('video-gallery-grid--few');
    }
  }

  /** Hide the whole gallery (heading + rail + Shopify section) — no empty-state placeholder. */
  function hideGallerySection() {
    markPriorityDone();
    root.innerHTML = '';
    var block = root.closest('.video-gallery-section') || root.closest('[data-wvg-block]');
    if (block) {
      block.style.display = 'none';
      block.setAttribute('hidden', '');
      block.setAttribute('aria-hidden', 'true');
    }
    var shopifySection =
      (block && block.closest('.shopify-section')) ||
      root.closest('.shopify-section--wom-pdp-video-gallery') ||
      root.closest('.shopify-section');
    if (shopifySection) {
      shopifySection.style.display = 'none';
      shopifySection.setAttribute('hidden', '');
      shopifySection.setAttribute('aria-hidden', 'true');
    }
  }

  function escapeHtml(s){
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]);
    });
  }

  function formatViews(n) {
    if (n == null || n === '' || isNaN(Number(n))) return '';
    var v = Number(n);
    if (v >= 1e6) return (v / 1e6).toFixed(1) + 'M Views';
    if (v >= 1e3) return (v / 1e3).toFixed(1) + 'K Views';
    return v + ' Views';
  }

  function shareIconSvg() {
    return '<svg class="vg-share-ico" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M14.0074 2.12578C13.8911 2.0095 13.7458 1.92634 13.5866 1.88487C13.4274 1.8434 13.2601 1.84511 13.1018 1.88983H13.0931L1.99328 5.25784C1.81259 5.3098 1.65202 5.41557 1.53295 5.56107C1.41388 5.70656 1.34196 5.88488 1.32676 6.07228C1.31156 6.25967 1.35381 6.44725 1.44788 6.61003C1.54195 6.77281 1.68338 6.90308 1.85333 6.98348L6.80471 9.32847L9.14971 14.2799C9.22374 14.4384 9.3416 14.5725 9.48936 14.6663C9.63712 14.76 9.80862 14.8095 9.98361 14.809C10.0102 14.809 10.0368 14.8078 10.0634 14.8055C10.2501 14.7904 10.4278 14.7185 10.5725 14.5996C10.7172 14.4806 10.8221 14.3202 10.873 14.1399L14.2387 3.04007C14.2387 3.03717 14.2387 3.03428 14.2387 3.03139C14.284 2.87349 14.2865 2.70638 14.2458 2.54723C14.2052 2.38807 14.1229 2.24261 14.0074 2.12578ZM9.98882 13.875L9.98592 13.8831L7.70975 9.07807L10.4416 6.34561C10.5247 6.25815 10.5704 6.14168 10.5688 6.02104C10.5673 5.9004 10.5187 5.78514 10.4334 5.69983C10.348 5.61452 10.2328 5.56591 10.1121 5.56436C9.9915 5.56282 9.87504 5.60846 9.78757 5.69156L7.05511 8.42344L2.24946 6.14726H2.25756L13.3528 2.78041L9.98882 13.875Z" fill="currentColor"/></svg>';
  }

  function shareUrlForEntry(entry) {
    if (!entry) return window.location.href;
    var p = entry.product;
    var handle = entry.productHandle || (p && p.handle) || '';
    var url = (p && p.url) || (handle ? productUrlForHandle(handle) : window.location.href);
    return url.indexOf('http') === 0 ? url : (window.location.origin + url);
  }

  function shareEntry(entry) {
    var shareU = shareUrlForEntry(entry);
    var title = (entry && entry.product && entry.product.title) || document.title || '';
    if (navigator.share) {
      navigator.share({ url: shareU, title: title }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(shareU).catch(function () {});
    }
  }

  function shareCurrentModalVideo() {
    shareEntry(getModalList()[modalIndex]);
  }

  function moneyFromCents(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
    } catch (e) {}
    var v = (Number(cents) || 0) / 100;
    return '₹' + v.toFixed(2);
  }

  function getFirstAvailableVariant(p) {
    if (!p || !Array.isArray(p.variants)) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) return p.variants[i];
    }
    return p.variants[0] || null;
  }

  function getFeaturedImageUrl(p) {
    if (!p) return '';
    if (p.featured_image) return p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image;
    if (p.image) return p.image.indexOf('//') === 0 ? 'https:' + p.image : p.image;
    if (Array.isArray(p.images) && p.images.length) return p.images[0];
    return '';
  }

  function productUrlForHandle(handle) {
    return handle ? (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'products/' + encodeURIComponent(handle) : '#';
  }

  function shopifyRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function normalizeApiHandle(raw) {
    var s = String(raw || '').trim();
    try {
      s = s.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\uFE0F]/gu, '');
    } catch (e) {
      s = s.replace(/[^\x00-\x7F]+/g, '');
    }
    s = s.replace(/^[\s\-_]+/, '').toLowerCase();
    return s;
  }

  function addLinkedHandleToIndex(index, video, fallbackHandle) {
    if (!video) return;
    var url = stripMediaUrl(video.url || video.s3_url || video.video_url || '');
    var vid = video.id || video.video_id;
    var handles = collectLinkedHandles(video, null);
    var handle = handles.length ? handles[0] : String(fallbackHandle || '').trim();
    if (!handle) return;
    if (url) index[url] = handle;
    if (vid) index['id:' + vid] = handle;
  }

  function buildVideoHandleIndex(data) {
    var index = {};
    if (!data) return index;
    var maps = [data.video_product_map, data.video_products_map];
    maps.forEach(function (map) {
      if (!map || typeof map !== 'object') return;
      Object.keys(map).forEach(function (videoId) {
        var hit = map[videoId];
        var handle = '';
        if (typeof hit === 'string') handle = hit.trim();
        else if (Array.isArray(hit) && hit.length) handle = String(hit[0]).trim();
        else if (hit && typeof hit === 'object') handle = String(hit.handle || hit.product_handle || '').trim();
        if (handle) index['id:' + videoId] = handle;
      });
    });
    if (data.product_videos && typeof data.product_videos === 'object') {
      Object.keys(data.product_videos).forEach(function (handle) {
        var arr = data.product_videos[handle];
        if (!Array.isArray(arr)) return;
        arr.forEach(function (v) {
          addLinkedHandleToIndex(index, v, handle);
        });
      });
    }
    ['company_videos', 'stories', 'videos'].forEach(function (key) {
      var list = data[key];
      if (!Array.isArray(list)) return;
      list.forEach(function (v) {
        addLinkedHandleToIndex(index, v, '');
      });
    });
    return index;
  }

  function fetchCollectionCatalog() {
    if (!CATALOG_HANDLE) return Promise.resolve([]);
    if (collectionCatalog.length) return Promise.resolve(collectionCatalog);
    return fetch(
      shopifyRoot() + 'collections/' + encodeURIComponent(CATALOG_HANDLE) + '/products.json?limit=250',
      { headers: { Accept: 'application/json' } }
    )
      .then(function (r) {
        if (!r.ok) return [];
        return r.json();
      })
      .then(function (payload) {
        collectionCatalog = payload && Array.isArray(payload.products) ? payload.products : [];
        if (collectionCatalog.length) return collectionCatalog;
        return fetch(shopifyRoot() + 'products.json?limit=250', { headers: { Accept: 'application/json' } })
          .then(function (r2) {
            if (!r2.ok) return [];
            return r2.json();
          })
          .then(function (payload2) {
            collectionCatalog = payload2 && Array.isArray(payload2.products) ? payload2.products : [];
            return collectionCatalog;
          })
          .catch(function () {
            return [];
          });
      })
      .catch(function () {
        collectionCatalog = [];
        return [];
      });
  }

  if (!catalogReady) catalogReady = fetchCollectionCatalog();

  function scoreProductMatch(apiNorm, product) {
    if (!product || !apiNorm) return 0;
    var handle = (product.handle || '').toLowerCase();
    var title = (product.title || '').toLowerCase();
    if (handle === apiNorm) return 100;
    if (apiNorm.indexOf(handle) !== -1 || handle.indexOf(apiNorm) !== -1) return 80;
    var tokens = apiNorm.split('-').filter(function (t) {
      return t.length > 2 && !/^\d+$/.test(t);
    });
    if (!tokens.length) return 0;
    var score = 0;
    tokens.forEach(function (t) {
      if (handle.indexOf(t) !== -1) score += 2;
      if (title.indexOf(t) !== -1) score += 1;
    });
    return score;
  }

  function matchHandleFromCatalog(apiHandle) {
    if (!apiHandle || !collectionCatalog.length) return '';
    var raw = String(apiHandle).trim();
    var norm = normalizeApiHandle(raw);
    var i;
    for (i = 0; i < collectionCatalog.length; i++) {
      if (collectionCatalog[i].handle === raw || collectionCatalog[i].handle === norm) {
        return collectionCatalog[i].handle;
      }
    }
    var best = '';
    var bestScore = 0;
    collectionCatalog.forEach(function (p) {
      var s = scoreProductMatch(norm, p);
      if (s > bestScore) {
        bestScore = s;
        best = p.handle;
      }
    });
    return bestScore >= 3 ? best : '';
  }

  function resolveShopifyHandle(apiHandle) {
    if (!apiHandle) return Promise.resolve('');
    return catalogReady.then(function () {
      var raw = String(apiHandle).trim();
      var norm = normalizeApiHandle(raw);
      var candidates = [];
      if (raw) candidates.push(raw);
      if (norm && candidates.indexOf(norm) === -1) candidates.push(norm);

      function tryNext(idx) {
        if (idx >= candidates.length) {
          var matched = matchHandleFromCatalog(raw);
          if (!matched) return Promise.resolve('');
          return fetchProductByHandle(matched).then(function () {
            return matched;
          });
        }
        return fetchProductByHandle(candidates[idx]).then(function (p) {
          if (p) return candidates[idx];
          return tryNext(idx + 1);
        });
      }

      return tryNext(0);
    });
  }

  function collectLinkedHandles(vOrEntry, data) {
    var out = [];
    function add(handle) {
      var h = String(handle || '').trim();
      if (h && out.indexOf(h) === -1) out.push(h);
    }
    if (!vOrEntry) return out;

    var lp = vOrEntry.linked_products || vOrEntry.linkedProducts || vOrEntry.product_handles;
    if (Array.isArray(lp)) {
      lp.forEach(add);
    } else if (typeof lp === 'string') {
      add(lp);
    }
    add(vOrEntry.productHandle);
    add(vOrEntry.product_handle);

    if (data) {
      add(pickProductHandle({ id: vOrEntry.id, linked_products: lp }, data));
      var shared = window.WOMVideoGallery || {};
      if (shared._lastApiData && shared._lastApiData !== data) {
        add(pickProductHandle({ id: vOrEntry.id }, shared._lastApiData));
      }
      if (shared._storiesApiData && shared._storiesApiData !== data) {
        add(pickProductHandle({ id: vOrEntry.id }, shared._storiesApiData));
      }
    }

    var indexes = [videoHandleIndex];
    var sharedGallery = window.WOMVideoGallery || {};
    if (sharedGallery._videoHandleIndex) indexes.push(sharedGallery._videoHandleIndex);
    var urlKey = stripMediaUrl(vOrEntry.s3_url || vOrEntry.url || vOrEntry.video_url || '');
    var i;
    for (i = 0; i < indexes.length; i++) {
      var idx = indexes[i];
      if (!idx) continue;
      if (urlKey && idx[urlKey]) add(idx[urlKey]);
      if (vOrEntry.id && idx['id:' + vOrEntry.id]) add(idx['id:' + vOrEntry.id]);
    }
    return out;
  }

  function resolveShopifyHandlesFromList(handles) {
    if (!handles || !handles.length) return Promise.resolve('');
    return catalogReady.then(function () {
      var i = 0;
      function tryNext() {
        if (i >= handles.length) return Promise.resolve('');
        var handle = String(handles[i++]).trim();
        if (!handle) return tryNext();
        return resolveShopifyHandle(handle).then(function (resolved) {
          if (resolved) return resolved;
          return tryNext();
        });
      }
      return tryNext();
    });
  }

  function inferApiProductHandle(entry, data) {
    var handles = collectLinkedHandles(entry, data);
    return handles.length ? handles[0] : '';
  }

  function refillPlaylistHandles(list) {
    if (!list || !list.length) return;
    list.forEach(function (entry) {
      if (!entry || entry.productHandle) return;
      var h = inferApiProductHandle(entry, lastWomApiData);
      if (h) entry.productHandle = h;
    });
  }

  function ensureEntryProduct(index) {
    var list = getModalList();
    if (!list || index < 0 || index >= list.length) return Promise.resolve(null);
    var entry = list[index];
    if (!entry) return Promise.resolve(null);

    if (entry.product && resolveEntryShopifyHandle(entry)) {
      if (!isDesktopModal() && feedBuilt && feed) {
        var slide = feed.querySelector('[data-slide-index="' + String(index) + '"]');
        if (slide && !slide.querySelector('.vg-slide__product')) {
          patchSlideProduct(index, entry.product);
        }
        if (modalIndex === index) refreshSlideMetaUi(index);
      } else if (isDesktopModal() && modalIndex === index) {
        setModalProductUi(entry.product, resolveEntryShopifyHandle(entry));
      }
      return Promise.resolve(entry.product);
    }

    var apiHandles = collectLinkedHandles(entry, lastWomApiData);
    if (!apiHandles.length) return Promise.resolve(null);

    return resolveShopifyHandlesFromList(apiHandles).then(function (shopifyH) {
      if (!shopifyH) return null;
      entry.productHandle = shopifyH;
      return fetchProductByHandle(shopifyH).then(function (product) {
        if (!product) return null;
        entry.product = product;
        if (isDesktopModal()) {
          if (modalIndex === index) setModalProductUi(product, shopifyH);
        } else if (feedBuilt) {
          patchSlideProduct(index, product);
          if (modalIndex === index) refreshSlideMetaUi(index);
        }
        var card = root.querySelector('.vg-card-outer[data-vg-index="' + index + '"]');
        if (card) applyProductToCard(card, product);
        return product;
      });
    });
  }

  function soundIconMuted() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  }

  function soundIconUnmuted() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M19 8a5 5 0 0 1 0 8"/></svg>';
  }

  function updateAllSoundIcons() {
    if (!feed) return;
    feed.querySelectorAll('.vg-slide__sound').forEach(function (btn) {
      btn.innerHTML = prefersMuted ? soundIconMuted() : soundIconUnmuted();
    });
  }

  function toggleGlobalMute() {
    prefersMuted = !prefersMuted;
    if (feed) {
      feed.querySelectorAll('[data-vg-slide-video]').forEach(function (v) {
        v.muted = prefersMuted;
      });
    }
    if (modalVideo) modalVideo.muted = prefersMuted;
    updateAllSoundIcons();
    updateDesktopMuteUi();
  }

  function updateDesktopMuteUi() {
    if (!muteBtn) return;
    muteBtn.setAttribute('aria-pressed', prefersMuted ? 'true' : 'false');
    muteBtn.setAttribute('aria-label', prefersMuted ? 'Unmute' : 'Mute');
    var icoMute = muteBtn.querySelector('.vg-ico-mute');
    var icoUnmute = muteBtn.querySelector('.vg-ico-unmute');
    if (icoMute && icoUnmute) {
      icoMute.style.display = prefersMuted ? '' : 'none';
      icoUnmute.style.display = prefersMuted ? 'none' : '';
    }
  }

  function enableAudioForOpen() {
    modalAudioUnlocked = true;
    prefersMuted = false;
    if (feed) {
      feed.querySelectorAll('[data-vg-slide-video]').forEach(function (v) {
        v.muted = false;
      });
    }
    if (modalVideo) modalVideo.muted = false;
    updateAllSoundIcons();
    updateDesktopMuteUi();
  }

  function shouldPlaySlideWithAudio() {
    return modalAudioUnlocked && !prefersMuted;
  }

  /** Try with audio when the user opened the modal; never poison global mute on failure. */
  function playVideoWithAudioPolicy(video) {
    if (!video) return Promise.resolve();
    var wantAudio = shouldPlaySlideWithAudio();
    video.muted = !wantAudio;
    return video.play().catch(function () {
      if (!wantAudio) return Promise.resolve();
      video.muted = true;
      return video.play().catch(function () {});
    });
  }

  function resolveEntryShopifyHandle(entry) {
    if (!entry) return '';
    var p = entry.product;
    if (p && p.handle) return String(p.handle);
    if (entry.productHandle) return String(entry.productHandle);
    return '';
  }

  function getDesktopMetaContainer() {
    if (!desktopShell) return modal;
    return desktopShell.querySelector('.vg-shell-card-meta') || desktopShell;
  }

  function refreshSlideMetaUi(index) {
    if (isDesktopModal()) return;
    var list = getModalList();
    if (!list || index < 0 || index >= list.length || !feed) return;
    var entry = list[index];
    if (!entry) return;
    var slide = feed.querySelector('[data-slide-index="' + String(index) + '"]');
    if (!slide) return;
    var productWrap = slide.querySelector('.vg-slide__product');
    if (!productWrap) return;
    var handle = resolveEntryShopifyHandle(entry);
    if (!handle) return;
    loadProductMetaUi(productWrap, handle, entry.product || null);
  }

  function setModalProductUi(product, handle) {
    var p = product || null;
    var h = handle || (p && p.handle) || '';
    var metaHandle = (p && p.handle) || h;
    var metaRoot = getDesktopMetaContainer();
    mountVideoRating(modalRatingEl, metaHandle);

    if (metaHandle) {
      loadProductMetaUi(metaRoot, metaHandle, p);
    } else {
      applyProductMetaUi(metaRoot, null, p);
    }

    if (!p) {
      if (titleEl) titleEl.textContent = '';
      if (modalPrices) modalPrices.textContent = '';
      if (modalImageWrap) modalImageWrap.setAttribute('data-empty', '1');
      if (modalImage) {
        modalImage.removeAttribute('src');
        modalImage.alt = '';
      }
      if (modalLink) {
        modalLink.href = '#';
        modalLink.setAttribute('aria-disabled', 'true');
        /* Keep View Product visible so the action row never collapses */
        modalLink.style.display = '';
      }
      if (modalAdd) {
        modalAdd.disabled = true;
        modalAdd.setAttribute('aria-disabled', 'true');
        modalAdd.removeAttribute('data-variant-id');
        modalAdd.textContent = VG_LBL.atc;
        /* Never hide ATC — product resolve is async; hiding looked like a bug */
        modalAdd.style.display = '';
      }
      return;
    }
    if (modalLink) {
      modalLink.style.display = '';
      modalLink.removeAttribute('aria-disabled');
    }
    if (modalAdd) modalAdd.style.display = '';
    var v0 = getFirstAvailableVariant(p);
    if (titleEl) titleEl.textContent = p.title || 'Product';
    if (modalPrices) {
      if (v0 && v0.price != null) {
        modalPrices.innerHTML = '<span class="vg-modal-price-now">' + moneyFromCents(Number(v0.price)) + '</span>';
      } else {
        modalPrices.textContent = '';
      }
    }
    if (modalImageWrap && modalImage) {
      var img = getFeaturedImageUrl(p);
      if (img) {
        modalImageWrap.removeAttribute('data-empty');
        modalImage.src = img;
        modalImage.alt = p.title || '';
      } else {
        modalImageWrap.setAttribute('data-empty', '1');
      }
    }
    if (modalLink) modalLink.href = p.url || productUrlForHandle(h);
    if (modalAdd) {
      if (v0 && v0.id) {
        modalAdd.disabled = v0.available === false;
        modalAdd.dataset.variantId = String(v0.id);
        if (v0.price != null) modalAdd.setAttribute('data-variant-price', String(v0.price));
        else modalAdd.removeAttribute('data-variant-price');
        if (p.type) modalAdd.setAttribute('data-product-type', p.type);
        else modalAdd.removeAttribute('data-product-type');
        modalAdd.textContent = v0.available === false ? 'Sold out' : VG_LBL.atc;
        modalAdd.removeAttribute('aria-disabled');
      } else {
        modalAdd.disabled = true;
        modalAdd.setAttribute('aria-disabled', 'true');
      }
    }
  }

  function getCardEl(index) {
    return root.querySelector('.vg-card-outer[data-vg-index="' + index + '"]');
  }

  function getCardPreviewVideo(index) {
    var card = getCardEl(index);
    return card ? card.querySelector('video[data-lazy-video]') : null;
  }

  function getCardPosterSrc(index, url) {
    var card = getCardEl(index);
    var img = card ? card.querySelector('[data-vg-poster]') : null;
    if (img && img.getAttribute('data-poster-ready') === '1' && img.src) return img.src;
    if (url && posterCache[url]) return posterCache[url];
    return '';
  }

  function getModalPosterSrc(index, url) {
    if (url && posterCache[url]) return posterCache[url];
    var list = getModalList();
    if (!isNaN(index) && list && list[index]) {
      var entry = list[index];
      if (entry.poster) return entry.poster;
      if (entry.s3_url && posterCache[entry.s3_url]) return posterCache[entry.s3_url];
    }
    if (!modalPlaylist) {
      var fromCard = getCardPosterSrc(index, url);
      if (fromCard) return fromCard;
    }
    if (url && window.WOMVideoPoster && window.WOMVideoPoster.thumbFromVideoUrl) {
      return window.WOMVideoPoster.thumbFromVideoUrl(url) || '';
    }
    return '';
  }

  function markShellHasFramePoster(on) {
    if (!desktopShell) return;
    var shellVideo = desktopShell.querySelector('.vg-shell-video');
    if (!shellVideo) return;
    if (on) shellVideo.classList.add('has-frame-poster');
    else shellVideo.classList.remove('has-frame-poster');
  }

  /**
   * Show a still IMAGE while the modal MP4 loads.
   * Never start a second <video> decoder for preview — that causes black/white flicker.
   */
  function showShellFramePoster(index, url) {
    var still = getModalPosterSrc(index, url);
    if (shellStillVideo) {
      shellStillVideo.classList.remove('is-visible');
      try { shellStillVideo.pause(); } catch (e) {}
    }
    if (still && shellStillImg) {
      shellStillImg.src = still;
      shellStillImg.classList.add('is-visible');
      markShellHasFramePoster(true);
      if (desktopShell) {
        var sv = desktopShell.querySelector('.vg-shell-video');
        if (sv) sv.classList.remove('is-poster-faded');
      }
      return true;
    }
    markShellHasFramePoster(false);
    return false;
  }

  function hideShellFramePosterLayers() {
    if (shellStillImg) {
      shellStillImg.classList.remove('is-visible');
    }
    if (shellStillVideo) {
      shellStillVideo.classList.remove('is-visible');
      try { shellStillVideo.pause(); } catch (e) {}
    }
  }

  function hideShellFramePoster() {
    hideShellFramePosterLayers();
    markShellHasFramePoster(false);
  }

  function showSlideFramePoster(slide, url) {
    if (!slide) return false;
    var stillImg = slide.querySelector('[data-vg-slide-still]');
    var stillVid = slide.querySelector('[data-vg-slide-still-video]');
    var idx = parseInt(slide.getAttribute('data-slide-index'), 10);
    var still = getModalPosterSrc(isNaN(idx) ? -1 : idx, url);

    if (stillVid) {
      stillVid.classList.remove('is-visible');
      try { stillVid.pause(); } catch (e) {}
    }
    if (stillImg) stillImg.classList.remove('is-visible');

    if (still && stillImg) {
      stillImg.src = still;
      stillImg.classList.add('is-visible');
      slide.classList.add('has-frame-poster');
      slide.classList.remove('is-poster-faded');
      return true;
    }
    return false;
  }

  var desktopRevealToken = 0;

  function stripMediaUrl(u) {
    if (!u) return '';
    return String(u).split('#')[0].split('?')[0];
  }

  function openDesktopModalAt(i) {
    if (!modal || !modalVideo) return;
    var list = getModalList();
    if (i < 0 || i >= list.length) return;
    modalIndex = i;
    var entry = list[modalIndex];
    if (!entry || !entry.s3_url) return;

    desktopRevealToken += 1;
    var token = desktopRevealToken;

    if (reelShell) reelShell.setAttribute('aria-hidden', 'true');
    if (desktopShell) desktopShell.setAttribute('aria-hidden', 'false');

    lockPageScroll();
    modal.setAttribute('aria-hidden', 'false');
    document.body.setAttribute('data-vg-modal-open', '1');
    modal.style.display = 'flex';

    enableAudioForOpen();

    if (desktopShell) {
      var shellVideo = desktopShell.querySelector('.vg-shell-video');
      if (shellVideo) shellVideo.classList.remove('is-video-ready');
    }

    /* Cheap sync work only — show still + title, then defer play for INP */
    showShellFramePoster(modalIndex, entry.s3_url);
    if (titleEl) titleEl.textContent = (entry.product && entry.product.title) || '';
    if (prevBtn) prevBtn.disabled = modalIndex <= 0;
    if (nextBtn) nextBtn.disabled = modalIndex >= list.length - 1;

    function startPlayback() {
      if (token !== desktopRevealToken) return;

      enableAudioForOpen();
      modalVideo.muted = false;

      var bare = stripMediaUrl(entry.s3_url);
      var curBare = stripMediaUrl(modalVideo.currentSrc || modalVideo.getAttribute('src') || '');
      if (curBare !== bare) {
        modalVideo.src = bare;
      }

      function reveal() {
        if (token !== desktopRevealToken) return;
        if (!desktopShell) return;
        var sv = desktopShell.querySelector('.vg-shell-video');
        if (sv) sv.classList.add('is-video-ready');
      }
      modalVideo.addEventListener('playing', reveal, { once: true });
      window.setTimeout(reveal, 1200);

      setModalProductUi(entry.product, resolveEntryShopifyHandle(entry));
      ensureEntryProduct(modalIndex);
      updateDesktopMuteUi();

      var tries = 0;
      function tryPlay() {
        if (token !== desktopRevealToken) return;
        tries++;
        playVideoWithAudioPolicy(modalVideo).catch(function () {
          if (tries < 3) setTimeout(tryPlay, 180);
        });
      }
      tryPlay();
    }

    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        requestAnimationFrame(startPlayback);
      });
    } else {
      window.setTimeout(startPlayback, 32);
    }
  }

  function getProductCardData(entry) {
    var p = (entry && entry.product) || null;
    if (!p) return null;
    var v0 = getFirstAvailableVariant(p);
    var img = getFeaturedImageUrl(p);
    var price = v0 && v0.price != null ? moneyFromCents(Number(v0.price)) : '';
    var url = p.url || productUrlForHandle(entry.productHandle || p.handle || '');
    return {
      title: p.title || 'Product',
      price: price,
      priceCents: v0 && v0.price != null ? String(v0.price) : '',
      productType: p.type || '',
      image: img,
      url: url,
      variantId: v0 && v0.id ? String(v0.id) : '',
      available: !(v0 && v0.available === false)
    };
  }

  function buildSlideProductHtml(entry) {
    var p = getProductCardData(entry);
    if (!p) return '';
    var img = p.image
      ? '<div class="vg-slide__product-thumb"><img class="vg-slide__product-img" src="' + escapeHtml(p.image) + '" alt="" loading="lazy" width="48" height="48"></div>'
      : '';
    var atcDisabled = !p.variantId || !p.available;
    return (
      '<div class="vg-slide__product-inner">' +
        img +
        '<div class="vg-slide__product-meta">' +
          '<p class="vg-slide__product-title">' + escapeHtml(p.title) + '</p>' +
          '<div class="vg-slide__labels labels-wrapper" data-vg-labels hidden></div>' +
          '<button type="button" class="vg-slide__view-desc-btn" data-vg-view-desc hidden>View Description</button>' +
          '<div class="vg-slide__description" data-vg-description hidden></div>' +
          (p.price ? '<p class="vg-slide__product-price">' + escapeHtml(p.price) + '</p>' : '') +
          '<div class="wom-video-product-rating" data-wom-video-rating hidden></div>' +
        '</div>' +
      '</div>' +
      '<div class="vg-slide__product-actions">' +
        '<button type="button" class="button button--primary vg-btn-atc" data-vg-add' +
          (atcDisabled ? ' disabled aria-disabled="true"' : '') +
          (p.variantId ? ' data-variant-id="' + escapeHtml(p.variantId) + '"' : '') +
          (p.priceCents ? ' data-variant-price="' + escapeHtml(p.priceCents) + '"' : '') +
          (p.productType ? ' data-product-type="' + escapeHtml(p.productType) + '"' : '') +
        '>' + escapeHtml(atcDisabled && p.variantId ? 'Sold out' : VG_LBL.atc) + '</button>' +
        '<a class="button button--primary" href="' + escapeHtml(p.url) + '">' + escapeHtml(VG_LBL.view) + '</a>' +
      '</div>' +
      '<div class="vg-slide__desc-panel" data-vg-desc-panel hidden>' +
        '<div class="vg-slide__desc-panel-inner">' +
          '<div class="vg-slide__desc-panel-header">' +
            '<span class="vg-slide__desc-panel-title">Product Description</span>' +
            '<button type="button" class="vg-slide__desc-panel-close" data-vg-desc-panel-close aria-label="Close">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="vg-slide__desc-panel-body" data-vg-desc-panel-body></div>' +
        '</div>' +
      '</div>'
    );
  }

  function patchSlideProduct(index, product) {
    if (!modalPlaylist || !feed || index < 0 || index >= modalPlaylist.length) return;
    var entry = modalPlaylist[index];
    if (!entry || !product) return;
    entry.product = product;
    if (product.handle) entry.productHandle = product.handle;
    var slide = feed.querySelector('[data-slide-index="' + String(index) + '"]');
    if (!slide) return;
    var html = buildSlideProductHtml(entry);
    if (!html) return;
    var productWrap = slide.querySelector('.vg-slide__product');
    if (!productWrap) {
      productWrap = document.createElement('div');
      productWrap.className = 'vg-slide__product';
      slide.appendChild(productWrap);
    }
    productWrap.innerHTML = html;
    var atcBtn = productWrap.querySelector('[data-vg-add]');
    if (atcBtn) bindAtc(atcBtn);
    mountVideoRating(
      productWrap.querySelector('[data-wom-video-rating]'),
      resolveEntryShopifyHandle(entry)
    );
    var slideHandle = resolveEntryShopifyHandle(entry);
    if (slideHandle && modalIndex === index) {
      loadProductMetaUi(productWrap, slideHandle, product);
    }
    bindSlideDescPanel(slide);
  }

  function bindSlideDescPanel(slide) {
    var viewBtn = slide.querySelector('[data-vg-view-desc]');
    var panel = slide.querySelector('[data-vg-desc-panel]');
    var closeBtn = slide.querySelector('[data-vg-desc-panel-close]');
    var panelBody = slide.querySelector('[data-vg-desc-panel-body]');
    var descEl = slide.querySelector('[data-vg-description]');
    if (!viewBtn || !panel || !panelBody) return;

    viewBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (descEl && descEl.innerHTML) {
        panelBody.innerHTML = descEl.innerHTML;
      }
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
    });

    function closePanel(e) {
      if (e) e.stopPropagation();
      panel.classList.remove('is-open');
      setTimeout(function () { panel.hidden = true; }, 250);
    }

    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    panel.addEventListener('click', function (e) {
      if (e.target === panel) closePanel(e);
    });
  }

  function playSlideVideo(slide) {
    if (!slide) return;
    var video = slide.querySelector('[data-vg-slide-video]');
    if (!video) return;

    var src = video.getAttribute('data-src');
    if (src && stripMediaUrl(video.currentSrc || video.getAttribute('src') || '') !== stripMediaUrl(src)) {
      video.src = src;
    }

    if (feed) {
      feed.querySelectorAll('.vg-slide').forEach(function (s) {
        if (s !== slide) {
          s.classList.remove('is-video-ready', 'has-frame-poster');
          var otherStill = s.querySelector('[data-vg-slide-still]');
          if (otherStill) otherStill.classList.remove('is-visible');
        }
      });
      feed.querySelectorAll('video').forEach(function (v) {
        if (v !== video && !v.hasAttribute('data-vg-slide-still-video')) v.pause();
      });
    }

    slide.classList.remove('is-video-ready');
    showSlideFramePoster(slide, src || video.getAttribute('data-src') || '');

    function markReady() {
      slide.classList.add('is-video-ready');
    }
    video.addEventListener('playing', markReady, { once: true });
    window.setTimeout(markReady, 1200);

    playVideoWithAudioPolicy(video);
  }

  function setupSlideObserver() {
    if (!feed) return;
    if (slideObserver) slideObserver.disconnect();

    slideObserver = new IntersectionObserver(
      function (entries) {
        if (Date.now() < suppressSlideObserverUntil) return;
        entries.forEach(function (entry) {
          var slide = entry.target;
          var video = slide.querySelector('[data-vg-slide-video]');
          if (!video) return;

          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            modalIndex = parseInt(slide.getAttribute('data-slide-index') || '0', 10);
            if (modal && modal.getAttribute('aria-hidden') === 'false') {
              enableAudioForOpen();
            }
            playSlideVideo(slide);
            refreshSlideMetaUi(modalIndex);
            ensureEntryProduct(modalIndex);
          } else if (!entry.isIntersecting || entry.intersectionRatio < 0.25) {
            video.pause();
          }
        });
      },
      { root: feed, threshold: [0, 0.25, 0.55, 0.85, 1] }
    );

    feed.querySelectorAll('.vg-slide').forEach(function (slide) {
      slideObserver.observe(slide);
    });
  }

  function buildFeedSlides() {
    if (!feed) return;
    if (slideObserver) {
      try {
        slideObserver.disconnect();
      } catch (eObs) {}
      slideObserver = null;
    }
    feed.innerHTML = '';
    feedBuilt = false;

    getModalList().forEach(function (entry, idx) {
      if (!entry || !entry.s3_url) return;

      var slide = document.createElement('div');
      slide.className = 'vg-slide';
      slide.setAttribute('data-slide-index', String(idx));

      var videoWrap = document.createElement('div');
      videoWrap.className = 'vg-slide__video-wrap';

      var stillImg = document.createElement('img');
      stillImg.className = 'vg-slide-frame-poster';
      stillImg.setAttribute('data-vg-slide-still', '');
      stillImg.setAttribute('alt', '');
      stillImg.setAttribute('aria-hidden', 'true');
      stillImg.setAttribute('decoding', 'async');
      videoWrap.appendChild(stillImg);

      var stillVid = document.createElement('video');
      stillVid.className = 'vg-slide-frame-poster';
      stillVid.setAttribute('data-vg-slide-still-video', '');
      stillVid.setAttribute('muted', '');
      stillVid.setAttribute('playsinline', '');
      stillVid.setAttribute('aria-hidden', 'true');
      stillVid.muted = true;
      videoWrap.appendChild(stillVid);

      var video = document.createElement('video');
      video.setAttribute('playsinline', '');
      video.setAttribute('loop', '');
      video.setAttribute('preload', 'none');
      video.setAttribute('data-vg-slide-video', '');
      video.muted = prefersMuted;
      video.setAttribute('data-src', entry.s3_url);
      videoWrap.appendChild(video);
      slide.appendChild(videoWrap);

      var soundBtn = document.createElement('button');
      soundBtn.type = 'button';
      soundBtn.className = 'vg-slide__sound';
      soundBtn.setAttribute('aria-label', prefersMuted ? 'Unmute' : 'Mute');
      soundBtn.innerHTML = prefersMuted ? soundIconMuted() : soundIconUnmuted();
      soundBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleGlobalMute();
      });
      slide.appendChild(soundBtn);

      var shareBtn = document.createElement('button');
      shareBtn.type = 'button';
      shareBtn.className = 'vg-slide__share';
      shareBtn.setAttribute('aria-label', 'Share');
      shareBtn.innerHTML = shareIconSvg();
      shareBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        shareEntry(entry);
      });
      slide.appendChild(shareBtn);

      var productHtml = buildSlideProductHtml(entry);
      if (productHtml) {
        var productWrap = document.createElement('div');
        productWrap.className = 'vg-slide__product';
        productWrap.innerHTML = productHtml;

        var atcBtn = productWrap.querySelector('[data-vg-add]');
        if (atcBtn) bindAtc(atcBtn);

        mountVideoRating(
          productWrap.querySelector('[data-wom-video-rating]'),
          entry.productHandle || (entry.product && entry.product.handle) || ''
        );

        var slideHandle = resolveEntryShopifyHandle(entry);
        if (slideHandle && modalIndex === idx) {
          loadProductMetaUi(productWrap, slideHandle, entry.product || null);
        }

        slide.appendChild(productWrap);
      }

      feed.appendChild(slide);
      showSlideFramePoster(slide, entry.s3_url);
    });

    feedBuilt = true;
    setupSlideObserver();
  }

  function openMobileModalAt(i) {
    if (!modal || !feed) return;
    var list = getModalList();
    if (i < 0 || i >= list.length) return;
    modalIndex = i;

    enableAudioForOpen();

    if (!feedBuilt) buildFeedSlides();
    snapFeedToIndex(modalIndex, false);

    if (reelShell) reelShell.setAttribute('aria-hidden', 'false');
    if (desktopShell) desktopShell.setAttribute('aria-hidden', 'true');

    lockPageScroll();
    modal.setAttribute('aria-hidden', 'false');
    document.body.setAttribute('data-vg-modal-open', '1');
    modal.style.display = 'flex';
    snapFeedToIndex(modalIndex, false);

    var entry = list[modalIndex];
    if (entry && resolveEntryShopifyHandle(entry)) {
      if (isDesktopModal()) {
        loadProductMetaUi(getDesktopMetaContainer(), resolveEntryShopifyHandle(entry), entry.product || null);
      }
    }
    ensureEntryProduct(modalIndex).then(function () {
      if (!isDesktopModal()) refreshSlideMetaUi(modalIndex);
      else if (entry && entry.product) {
        setModalProductUi(entry.product, resolveEntryShopifyHandle(entry));
      }
    });
    suppressSlideObserverUntil = Date.now() + 900;
    var slide = feed.querySelector('[data-slide-index="' + modalIndex + '"]');
    if (slide) {
      showSlideFramePoster(slide, entry && entry.s3_url ? entry.s3_url : '');
      playSlideVideo(slide);
    }
  }

  function openModalAt(i) {
    if (isDesktopModal()) openDesktopModalAt(i);
    else openMobileModalAt(i);
  }

  /**
   * Open this gallery's modal with an external list (homepage story rings).
   * Does not change the card rail playlist.
   */
  function openExternalPlaylist(entries, startIndex) {
    if (!modal || !Array.isArray(entries) || !entries.length) return false;
    var normalized = [];
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (!e) continue;
      var url = e.s3_url || e.url || e.video_url || '';
      if (!url) continue;
      var linkedProducts = e.linked_products || e.linkedProducts || [];
      if ((!linkedProducts || !linkedProducts.length) && e.video) {
        linkedProducts = e.video.linked_products || e.video.linkedProducts || [];
      }
      normalized.push({
        s3_url: url,
        productHandle: e.productHandle || e.product_handle || '',
        linked_products: Array.isArray(linkedProducts) ? linkedProducts.slice() : [],
        product_handle: e.product_handle || '',
        product: e.product || null,
        id: e.id || null,
        views: e.views,
        poster: e.poster || e.thumbnail || e.thumbnail_url || ''
      });
      if (url && (e.poster || e.thumbnail || e.thumbnail_url)) {
        posterCache[url] = e.poster || e.thumbnail || e.thumbnail_url;
      }
    }
    if (!normalized.length) return false;

    var sharedGallery = window.WOMVideoGallery || {};
    if (!lastWomApiData && sharedGallery._lastApiData) {
      lastWomApiData = sharedGallery._lastApiData;
    }
    if (sharedGallery._videoHandleIndex) {
      videoHandleIndex = Object.assign({}, sharedGallery._videoHandleIndex, videoHandleIndex);
    }

    normalized.forEach(function (entry) {
      if (entry.product && entry.product.handle) {
        entry.productHandle = entry.product.handle;
        productCache[entry.product.handle] = entry.product;
      } else if (entry.product && entry.productHandle) {
        productCache[entry.productHandle] = entry.product;
      }
    });
    normalized.forEach(function (entry) {
      if (entry.product || !entry.productHandle) return;
      if (Object.prototype.hasOwnProperty.call(productCache, entry.productHandle)) {
        entry.product = productCache[entry.productHandle];
      }
    });

    modalPlaylist = normalized;
    refillPlaylistHandles(modalPlaylist);
    feedBuilt = false;
    if (feed) {
      feed.scrollTop = 0;
      feed.innerHTML = '';
    }

    var idx = parseInt(startIndex, 10);
    if (isNaN(idx) || idx < 0) idx = 0;
    if (idx >= modalPlaylist.length) idx = 0;

    // Resolve product for the opened slide; others load when scrolled into view.
    var openedEntry = modalPlaylist[idx];
    if (openedEntry && !openedEntry.product) {
      var openHandles = collectLinkedHandles(openedEntry, lastWomApiData);
      if (openHandles.length) {
        resolveShopifyHandlesFromList(openHandles).then(function (shopifyH) {
          if (!shopifyH || !modalPlaylist || modalPlaylist[idx] !== openedEntry) return;
          openedEntry.productHandle = shopifyH;
          return fetchProductByHandle(shopifyH).then(function (product) {
            if (!product || !modalPlaylist || modalPlaylist[idx] !== openedEntry) return;
            openedEntry.product = product;
            if (isDesktopModal()) {
              if (modalIndex === idx) {
                if (titleEl) titleEl.textContent = product.title || '';
                setModalProductUi(product, shopifyH);
              }
              return;
            }
            patchSlideProduct(idx, product);
          });
        });
      }
    }

    openModalAt(idx);
    ensureEntryProduct(idx);
    return true;
  }

  function closeModal() {
    if (!modal) return;
    modalAudioUnlocked = false;
    unlockPageScroll();
    document.body.removeAttribute('data-vg-modal-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.style.display = 'none';
    if (reelShell) reelShell.setAttribute('aria-hidden', 'true');
    if (desktopShell) desktopShell.setAttribute('aria-hidden', 'true');
    hideShellFramePoster();
    if (feed) {
      feed.scrollTop = 0;
      feed.querySelectorAll('video').forEach(function (v) {
        try { v.pause(); } catch (e) {}
      });
    }
    if (modalVideo) {
      try {
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modalVideo.load();
      } catch (e) {}
    }
    if (modalPlaylist) {
      modalPlaylist = null;
      feedBuilt = false;
      if (feed) feed.innerHTML = '';
    }
  }

  function registerGalleryApi() {
    var G = (window.WOMVideoGallery = window.WOMVideoGallery || { _list: [] });
    G._list = G._list.filter(function (c) {
      return c.instanceId !== instanceId;
    });
    G._list.push({
      instanceId: instanceId,
      displayLocation: DISPLAY_LOCATION,
      openAt: openModalAt,
      openExternal: openExternalPlaylist
    });
    G.openExternal = function (entries, index) {
      var home = null;
      for (var gi = 0; gi < G._list.length; gi++) {
        if (G._list[gi].displayLocation === 'homepage') {
          home = G._list[gi];
          break;
        }
      }
      var c = home || G._list[0];
      return c ? c.openExternal(entries, index) : false;
    };
  }
  registerGalleryApi();
  bindModal();

  function bindAtc(btn) {
    if (window.WomVideoCart) window.WomVideoCart.bind(btn);
  }

  var productCache = {};
  var productMetaCache = {};

  function productMetaUrl(handle) {
    return productUrlForHandle(handle) + '?view=wom-meta';
  }

  function stripHtml(html) {
    if (!html) return '';
    var el = document.createElement('div');
    el.innerHTML = String(html);
    return (el.textContent || el.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeDescriptionValue(value) {
    if (value == null) return '';
    if (typeof value === 'string') {
      var text = value.trim();
      return text === '[object Object]' ? '' : text;
    }
    return String(value).trim();
  }

  function resolveDescriptionText(meta, product) {
    var fromMeta = meta && meta.metafields && meta.metafields.product_description;
    var text = normalizeDescriptionValue(fromMeta);
    if (text) return text;
    return '';
  }

  function loadProductMetaUi(container, handle, product) {
    if (!handle) {
      applyProductMetaUi(container, null, product);
      return;
    }
    Promise.all([
      fetchProductMeta(handle),
      product ? Promise.resolve(product) : fetchProductByHandle(handle)
    ]).then(function (results) {
      applyProductMetaUi(container, results[0], results[1] || product || null);
    });
  }

  function parseProductMetaResponse(data) {
    if (data && data.success === true && data.metafields) return data;
    return null;
  }

  var LABEL_ORDER = ['red', 'green', 'yellow', 'pink', 'blue'];

  function getPdpDescription(meta, product) {
    return resolveDescriptionText(meta, product) || null;
  }

  function buildDescriptionMarkup(text) {
    if (!text) return '';
    return (
      '<div class="vg-meta-desc-wrap" data-vg-desc-wrap data-expanded="false">' +
        '<div class="vg-meta-desc-text rte" data-vg-desc-content>' + escapeHtml(text) + '</div>' +
        '<button type="button" class="vg-meta-desc-toggle" data-vg-desc-toggle>Read more</button>' +
      '</div>'
    );
  }

  function bindDescriptionToggle(descEl) {
    if (!descEl) return;
    var wrap = descEl.querySelector('[data-vg-desc-wrap]');
    var toggle = descEl.querySelector('[data-vg-desc-toggle]');
    if (!wrap || !toggle || toggle.getAttribute('data-bound') === '1') return;

    toggle.setAttribute('data-bound', '1');
    toggle.addEventListener('click', function () {
      var expanded = wrap.getAttribute('data-expanded') === 'true';
      if (expanded) {
        wrap.setAttribute('data-expanded', 'false');
        toggle.textContent = 'Read more';
        descEl.classList.remove('is-expanded');
      } else {
        wrap.setAttribute('data-expanded', 'true');
        toggle.textContent = 'Read less';
        descEl.classList.add('is-expanded');
      }
    });
  }

  function getProductMetaCopy(meta, product) {
    if (!meta || !meta.metafields) {
      meta = { metafields: {} };
    }
    var mf = meta.metafields;
    var labels = [];
    var labelMap = mf.labels || {};
    LABEL_ORDER.forEach(function (color) {
      var text = labelMap[color];
      if (text) labels.push({ color: color, text: String(text) });
    });

    var descriptionHtml = '';
    var pdpDesc = getPdpDescription(meta, product);
    if (pdpDesc) descriptionHtml = buildDescriptionMarkup(pdpDesc);

    return { labels: labels, descriptionHtml: descriptionHtml };
  }

  function renderProductLabelsHtml(labels) {
    if (!labels || !labels.length) return '';
    return labels
      .map(function (item) {
        return (
          '<span class="labels is-' +
          escapeHtml(item.color) +
          '">' +
          escapeHtml(item.text) +
          '</span>'
        );
      })
      .join('');
  }

  function applyProductMetaUi(container, meta, product) {
    if (!container) return;
    var copy = getProductMetaCopy(meta, product);
    var descEl = container.querySelector('[data-vg-description]');
    var labelsEl = container.querySelector('[data-vg-labels]');
    if (labelsEl) {
      if (copy.labels.length) {
        labelsEl.innerHTML = renderProductLabelsHtml(copy.labels);
        labelsEl.hidden = false;
      } else {
        labelsEl.innerHTML = '';
        labelsEl.hidden = true;
      }
    }
    if (descEl) {
      var viewDescBtn = container.querySelector('[data-vg-view-desc]');
      var isMobileSlide = !!container.closest('.vg-slide');
      if (copy.descriptionHtml) {
        descEl.innerHTML = copy.descriptionHtml;
        if (isMobileSlide) {
          descEl.hidden = true;
          if (viewDescBtn) viewDescBtn.hidden = false;
          bindSlideDescPanel(container.closest('.vg-slide'));
        } else {
          descEl.hidden = false;
          bindDescriptionToggle(descEl);
        }
      } else {
        descEl.innerHTML = '';
        descEl.hidden = true;
        descEl.classList.remove('is-expanded');
        if (viewDescBtn) viewDescBtn.hidden = true;
      }
    }
  }

  async function fetchProductMeta(handle) {
    if (!handle) return null;
    if (Object.prototype.hasOwnProperty.call(productMetaCache, handle)) {
      return productMetaCache[handle];
    }
    if (productMetaCache._pending && productMetaCache._pending[handle]) {
      return productMetaCache._pending[handle];
    }
    if (!productMetaCache._pending) productMetaCache._pending = {};

    productMetaCache._pending[handle] = (async function () {
      try {
        var url = productMetaUrl(handle);
        var r = await fetch(url, { cache: 'no-store' });
        var text = await r.text();
        var data = null;
        try {
          data = JSON.parse(text);
        } catch (parseErr) {
          productMetaCache[handle] = null;
          return null;
        }
        if (!r.ok) {
          productMetaCache[handle] = null;
          return null;
        }
        var parsed = parseProductMetaResponse(data);
        productMetaCache[handle] = parsed;
        return parsed;
      } catch (e) {
        productMetaCache[handle] = null;
        return null;
      } finally {
        if (productMetaCache._pending) delete productMetaCache._pending[handle];
      }
    })();

    return productMetaCache._pending[handle];
  }

  async function fetchProductByHandle(handle) {
    if (!handle) return null;
    if (Object.prototype.hasOwnProperty.call(productCache, handle)) return productCache[handle];
    if (productCache._pending && productCache._pending[handle]) {
      return productCache._pending[handle];
    }
    if (!productCache._pending) productCache._pending = {};

    productCache._pending[handle] = (async function () {
      try {
        var r = await fetch(productUrlForHandle(handle) + '.js', { headers: { Accept: 'application/json' } });
        if (!r.ok) {
          productCache[handle] = null;
          return null;
        }
        var p = await r.json();
        productCache[handle] = p;
        return p;
      } catch (e) {
        productCache[handle] = null;
        return null;
      } finally {
        if (productCache._pending) delete productCache._pending[handle];
      }
    })();

    return productCache._pending[handle];
  }

  async function fetchMappedProduct() {
    return fetchProductByHandle(MAPPED_HANDLE);
  }

  function resolveHandleFromMaps(videoId, data) {
    if (!videoId || !data) return '';
    var mapA = data.video_product_map || {};
    var mapB = data.video_products_map || {};
    var hit = mapA[videoId] || mapB[videoId];
    if (!hit) return '';
    if (typeof hit === 'string') return hit;
    if (Array.isArray(hit) && hit.length) {
      var first = hit[0];
      return typeof first === 'string' ? first : (first && (first.handle || first.product_handle)) || '';
    }
    if (typeof hit === 'object') return hit.handle || hit.product_handle || '';
    return '';
  }

  function flattenProductVideos(productVideos) {
    var out = [];
    if (!productVideos || typeof productVideos !== 'object' || Array.isArray(productVideos)) return out;
    Object.keys(productVideos).forEach(function (handle) {
      var arr = productVideos[handle];
      if (!Array.isArray(arr)) return;
      arr.forEach(function (v) {
        if (!v || !(v.url || v.s3_url || v.video_url)) return;
        out.push(Object.assign({}, v, {
          productHandle: handle,
          product_handle: handle
        }));
      });
    });
    return out;
  }

  function pickProductHandle(v, data) {
    if (!v) return '';
    var handle = v.productHandle || v.product_handle || '';
    if (handle) return String(handle).trim();
    handle = resolveHandleFromMaps(v.id, data);
    if (handle) return String(handle).trim();
    var lp = v.linked_products || v.linkedProducts || v.product_handles;
    if (Array.isArray(lp) && lp.length) return String(lp[0]).trim();
    if (typeof lp === 'string' && lp.trim()) return lp.trim();
    return '';
  }

  function normalizeFromWom(data) {
    if (!data || data.success !== true) return [];
    var companyList = Array.isArray(data.company_videos) ? data.company_videos.slice() : [];
    var storyList = Array.isArray(data.stories) ? data.stories.slice() : [];
    var videosList = Array.isArray(data.videos) ? data.videos.slice() : [];
    var fromProducts = flattenProductVideos(data.product_videos);

    // Homepage should use company/unlinked videos when present — not old product_videos
    var list = [];
    if (DISPLAY_LOCATION === 'homepage' || DISPLAY_LOCATION === '') {
      if (companyList.length) list = companyList;
      else if (storyList.length) list = storyList;
      else if (videosList.length) list = videosList;
      else list = fromProducts;
    } else if (DISPLAY_LOCATION === 'review_section' || DISPLAY_LOCATION === 'product_page') {
      list = fromProducts.length ? fromProducts : companyList.concat(videosList);
    } else {
      list = companyList.concat(videosList).concat(fromProducts);
    }

    var seen = {};
    var normalized = list.map(function (v) {
      if (!v) return null;
      var url = v.url || v.s3_url || v.video_url || '';
      if (!url) return null;
      var key = v.id || url;
      if (seen[key]) return null;
      seen[key] = true;
      var handle = pickProductHandle(v, data);
      var linkedProducts = v.linked_products || v.linkedProducts || v.product_handles || [];
      if (!Array.isArray(linkedProducts)) linkedProducts = linkedProducts ? [linkedProducts] : [];
      return {
        s3_url: url,
        id: v.id,
        views: v.views || v.view_count,
        apiTitle: v.filename || v.title || null,
        display_locations: v.display_locations || [],
        productHandle: handle,
        linked_products: linkedProducts.slice(),
        product_handle: v.product_handle || '',
        uploadedAt: v.uploaded_at || v.created_at || '',
        // Explicit API still only in normalize — derived siblings are probed in loadInto.
        poster: (window.WOMVideoPoster
          ? window.WOMVideoPoster.resolveTrusted({ video: v })
          : (v.thumbnail || v.thumbnail_url || v.poster || v.cover || v.cover_image || v.preview_image || '')),
        thumbnail: v.thumbnail || v.thumbnail_url || '',
        product: null
      };
    }).filter(Boolean);

    /* Seed poster cache with API thumbnails so modals/rails reuse them */
    normalized.forEach(function (entry) {
      if (entry && entry.s3_url && entry.poster) {
        posterCache[entry.s3_url] = entry.poster;
      }
    });

    return normalized;
  }

  function locationAllowed(locs, wanted) {
    if (!wanted) return true;
    if (!Array.isArray(locs) || !locs.length) return true;
    var aliases = {
      homepage: ['homepage', 'both'],
      product_page: ['product_page', 'both', 'review_section'],
      review_section: ['review_section', 'both']
    };
    var allowed = aliases[wanted] || [wanted];
    for (var i = 0; i < locs.length; i++) {
      if (allowed.indexOf(locs[i]) !== -1) return true;
    }
    return false;
  }

  function filterByLocation(list) {
    if (!DISPLAY_LOCATION) return list;
    return list.filter(function (v) {
      return locationAllowed(v.display_locations, DISPLAY_LOCATION);
    });
  }

  function cleanVideoLabel(raw, fallback) {
    var s = String(raw || fallback || 'Customer video');
    s = s.replace(/\.[a-z0-9]+$/i, '').replace(/[_-]+/g, ' ').trim();
    if (!s) s = 'Customer video';
    return s.length > 48 ? s.slice(0, 47) + '…' : s;
  }

  function applyProductToCard(cardEl, product) {
    if (!cardEl || !product) return;
    var handle = cardEl.getAttribute('data-vg-handle') || MAPPED_HANDLE || product.handle || '';
    var title = product.title || LIQUID_PRODUCT.title || 'Product';
    var v0 = getFirstAvailableVariant(product);
    var imgUrl = getFeaturedImageUrl(product) || LIQUID_PRODUCT.image || '';
    var productUrl = product.url || LIQUID_PRODUCT.url || productUrlForHandle(handle);

    cardEl.classList.remove('vg-card-outer--unlinked');

    var tEl = cardEl.querySelector('.vg-card-title');
    if (tEl) {
      tEl.textContent = title;
      if (productUrl && productUrl !== '#') {
        if (tEl.tagName === 'A') {
          tEl.href = productUrl;
        } else {
          var link = document.createElement('a');
          link.className = tEl.className || 'vg-card-title';
          link.href = productUrl;
          link.textContent = title;
          tEl.replaceWith(link);
          tEl = link;
        }
      }
    }

    var pEl = cardEl.querySelector('[data-vg-card-price]');
    if (pEl) {
      if (v0 && v0.price != null) {
        pEl.textContent = moneyFromCents(Number(v0.price));
        pEl.removeAttribute('aria-hidden');
      } else if (LIQUID_PRODUCT.priceCents !== '') {
        pEl.textContent = moneyFromCents(Number(LIQUID_PRODUCT.priceCents));
        pEl.removeAttribute('aria-hidden');
      } else {
        pEl.textContent = '';
        pEl.setAttribute('aria-hidden', 'true');
      }
    }

    var thWrap = cardEl.querySelector('.vg-card-thumb-wrap');
    if (thWrap && imgUrl) {
      thWrap.innerHTML = '';
      var im = document.createElement('img');
      im.className = 'vg-card-thumb';
      im.src = imgUrl;
      im.alt = title;
      im.loading = 'lazy';
      im.width = 52;
      im.height = 52;
      thWrap.appendChild(im);
    }

    var atc = cardEl.querySelector('.vg-btn-atc');
    if (atc) {
      if (v0 && v0.id) {
        atc.textContent = '+ ' + VG_LBL.atc;
        atc.disabled = v0.available === false;
        atc.dataset.variantId = String(v0.id);
        if (v0.price != null) atc.setAttribute('data-variant-price', String(v0.price));
        if (product && product.type) atc.setAttribute('data-product-type', product.type);
        if (v0.available === false) atc.setAttribute('aria-disabled', 'true');
        else atc.removeAttribute('aria-disabled');
        if (!atc.getAttribute('data-vg-atc-bound')) {
          atc.setAttribute('data-vg-atc-bound', '1');
          bindAtc(atc);
        }
      } else {
        atc.disabled = true;
        atc.setAttribute('aria-disabled', 'true');
      }
    }
  }

  function mountCardPosterSync(posterEl, card, url, thumbUrl) {
    if (!posterEl || !url) return '';
    if (!thumbUrl) thumbUrl = posterCache[url] || '';
    if (!thumbUrl && window.WOMVideoPoster && window.WOMVideoPoster.thumbFromVideoUrl) {
      thumbUrl = window.WOMVideoPoster.thumbFromVideoUrl(url) || '';
    }
    if (!thumbUrl) return '';

    posterCache[url] = thumbUrl;
    posterEl.removeAttribute('data-poster-ready');
    posterEl.setAttribute('data-poster-loading', '1');
    posterEl.classList.remove('is-loaded');
    if (card) card.classList.add('vg-card-outer--has-poster');

    function reveal() {
      if (!posterEl.naturalWidth) return;
      posterEl.classList.add('is-loaded');
      posterEl.setAttribute('data-poster-ready', '1');
      posterEl.removeAttribute('data-poster-loading');
      if (card) card.classList.add('vg-card-outer--has-poster');
    }

    posterEl.onload = function () {
      posterEl.onload = null;
      posterEl.onerror = null;
      reveal();
    };
    posterEl.onerror = function () {
      posterEl.onload = null;
      posterEl.onerror = null;
    };
    posterEl.decoding = 'async';

    if (posterEl.getAttribute('src') !== thumbUrl) posterEl.src = thumbUrl;
    else if (posterEl.complete && posterEl.naturalWidth > 0) reveal();

    return thumbUrl;
  }

  function createCard(video, index) {
    var handle = video.productHandle || '';
    var product = video.product || null;
    // Footer must exist whenever we have a handle, even before Shopify
    // product.js returns — otherwise enrich has nowhere to write title/thumb.
    var showProductFooter = !!(handle || (product && product.title));
    var productUrl = handle
      ? ((product && product.url) || productUrlForHandle(handle))
      : '';
    var displayTitle = (product && product.title) || '';
    var viewsL = formatViews(video.views);

    var videoItem = document.createElement('div');
    videoItem.className = 'vg-card-outer video-gallery-item' + (showProductFooter ? '' : ' vg-card-outer--unlinked');
    videoItem.dataset.vgIndex = String(index);
    videoItem.dataset.apiIndex = String(index);
    if (video.id) videoItem.dataset.videoId = String(video.id);
    if (handle) videoItem.dataset.vgHandle = handle;
    videoItem.setAttribute('role', 'listitem');
    videoItem.innerHTML = ''
      + '<div class="vg-card-inner">'
      +   '<div class="vg-card-media">'
      +     '<div class="vg-card-media-backdrop" aria-hidden="true"></div>'
      +     '<img class="vg-card-poster" data-vg-poster alt="" decoding="async" aria-hidden="true">'
      +     '<video class="video-gallery-preview" muted loop playsinline preload="none" data-lazy-video></video>'
      +     '<div class="vg-card-badges">'
      +       (viewsL ? '<span class="vg-views-pill">' + viewsL + '</span>' : '<span class="vg-views-pill" style="visibility:hidden">&nbsp;</span>')
      +     '</div></div>'
      +   (showProductFooter
        ? ('<div class="vg-card-footer">'
      +     '<div class="vg-card-product-row">'
      +       '<div class="vg-card-thumb-wrap"><div class="vg-card-thumb vg-card-thumb--placeholder" aria-hidden="true"></div></div>'
      +       '<div class="vg-card-titles">'
      +         (productUrl && productUrl !== '#'
          ? '<a class="vg-card-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(displayTitle || 'Loading…') + '</a>'
          : '<div class="vg-card-title">' + escapeHtml(displayTitle || 'Loading…') + '</div>')
      +         '<div class="vg-card-price" data-vg-card-price aria-hidden="true"></div>'
      +       '</div>'
      +     '</div>'
      +     '<div class="product-item__cta-wrapper vg-card-actions">'
      +       '<button type="button" class="product-item__cta button button--primary vg-btn-atc" disabled aria-disabled="true">+ ' + escapeHtml(VG_LBL.atc) + '</button>'
      +     '</div>'
      +   '</div>')
        : '')
      + '</div>';

    var vEl = videoItem.querySelector('video[data-lazy-video]');
    if (vEl) {
      vEl.dataset.src = video.s3_url;
    }

    var posterEl = videoItem.querySelector('[data-vg-poster]');
    if (posterEl) {
      posterEl.dataset.src = video.s3_url;
      var thumbUrl = video.poster || '';
      if (!thumbUrl && window.WOMVideoPoster && window.WOMVideoPoster.thumbFromVideoUrl) {
        thumbUrl = window.WOMVideoPoster.thumbFromVideoUrl(video.s3_url) || '';
      }
      mountCardPosterSync(posterEl, videoItem, video.s3_url, thumbUrl);
    }
    if (vEl) bindPreviewReveal(vEl);

    videoItem.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('a.vg-card-title, a.button, button.button, .vg-btn-atc')) return;
      e.preventDefault();
      var idx = parseInt(videoItem.dataset.vgIndex, 10);
      if (!isNaN(idx)) openModalAt(idx);
    });

    if (product) applyProductToCard(videoItem, product);

    return videoItem;
  }

  /** Bind reveal classes when a preview video paints. */
  function bindPreviewReveal(vEl) {
    if (!vEl || vEl._vgRevealBound) return;
    vEl._vgRevealBound = true;
    var card = vEl.closest ? vEl.closest('.vg-card-outer') : null;
    if (!card) return;

    function showFrame() {
      card.classList.add('vg-card-outer--has-frame');
      card.classList.add('vg-card-outer--video-ready');
      card.classList.remove('vg-card-outer--video-pending');
    }
    function hideFrame() {
      card.classList.remove('vg-card-outer--video-ready');
      card.classList.remove('vg-card-outer--has-frame');
      card.classList.remove('vg-card-outer--video-pending');
    }

    vEl.addEventListener('loadeddata', showFrame);
    vEl.addEventListener('loadedmetadata', showFrame);
    vEl.addEventListener('seeked', showFrame);
    vEl.addEventListener('playing', showFrame);
    vEl.addEventListener('timeupdate', function onTick() {
      if (vEl.currentTime > 0) {
        vEl.removeEventListener('timeupdate', onTick);
        showFrame();
      }
    });
    vEl.addEventListener('emptied', hideFrame);
    vEl.addEventListener('error', hideFrame);
    if (vEl.readyState >= 2) showFrame();
  }

  function estimateCardWidth() {
    var card = root.querySelector('.vg-card-outer');
    if (card && card.offsetWidth) return card.offsetWidth;
    return 180;
  }

  function enrichCardRange(fromIdx, toIdx) {
    var slice = playlist.slice(fromIdx, toIdx);
    if (!slice.length) return Promise.resolve();

    var jobs = [];
    slice.forEach(function (item, offset) {
      var index = fromIdx + offset;
      if (!playlist[index] || playlist[index].product) return;
      var handles = collectLinkedHandles(item, lastWomApiData);
      if (!handles.length) {
        playlist[index].product = null;
        return;
      }
      jobs.push({ index: index, handles: handles });
    });

    if (!jobs.length) return Promise.resolve();
    return Promise.all(
      jobs.map(function (job) {
        return resolveShopifyHandlesFromList(job.handles).then(function (shopifyH) {
          if (!shopifyH || !playlist[job.index]) return null;
          return fetchProductByHandle(shopifyH).then(function (product) {
            if (!product || !playlist[job.index]) return null;
            playlist[job.index].productHandle = shopifyH;
            playlist[job.index].product = product;
            var card = root.querySelector('.vg-card-outer[data-vg-index="' + job.index + '"]');
            if (card) applyProductToCard(card, product);
            return product;
          });
        });
      })
    );
  }

  function appendNextPage() {
    if (appendingPage) return;
    if (renderedCount >= playlist.length) return;
    appendingPage = true;

    var from = renderedCount;
    var to = Math.min(playlist.length, renderedCount + getAppendPage());
    for (var i = from; i < to; i++) {
      root.appendChild(createCard(playlist[i], i));
    }
    renderedCount = to;
    updateGridAlignment(renderedCount);
    appendingPage = false;
    // Do not preload every new batch's MP4s — that freezes scroll on slow 4G.
    if (railLazyApi && railLazyApi.observeCards) railLazyApi.observeCards();
    if (railLazyApi && railLazyApi.refresh) railLazyApi.refresh();
    // Enrich after paint so append stays cheap under CPU throttle.
    var enrichFrom = from;
    var enrichTo = to;
    var runEnrich = function () {
      enrichCardRange(enrichFrom, enrichTo);
    };
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(runEnrich, { timeout: 1200 });
    } else {
      setTimeout(runEnrich, 200);
    }
  }

  function ensureCardsThrough(needCount) {
    var guard = 0;
    while (renderedCount < needCount && renderedCount < playlist.length && guard < 20) {
      guard += 1;
      var before = renderedCount;
      appendNextPage();
      if (renderedCount === before) break;
    }
  }

  /**
   * Phone: when near the end of the current loaded set, append the next page.
   */
  function maybeLoadNextPhoneBatch(activeIdx) {
    maybeExpandRailFromScroll(activeIdx);
  }

  function maybeAppendFromScroll() {
    if (renderedCount >= playlist.length) return;
    var viewLeft = root.scrollLeft;
    var viewWidth = root.clientWidth || root.offsetWidth || 0;
    var scrollWidth = root.scrollWidth || 0;
    if (viewWidth <= 0) return;
    var remaining = scrollWidth - (viewLeft + viewWidth);
    var trigger = estimateCardWidth() * getPrefetchCards();
    if (remaining <= trigger) appendNextPage();
  }

  function ensurePreviewSrc(vEl) {
    if (!vEl) return;
    bindPreviewReveal(vEl);
    var u = vEl.dataset.src || '';
    if (!u) return;
    if (vEl.dataset.mounted === '1') return;
    vEl.dataset.mounted = '1';
    // #t=0.1 asks the browser for an early frame — that frame IS our thumbnail.
    vEl.src = u + (u.indexOf('#') === -1 ? '#t=0.1' : '');
    vEl.setAttribute('playsinline', '');
    vEl.setAttribute('preload', 'auto');
    vEl.muted = true;
    vEl.loop = true;
    var card = vEl.closest ? vEl.closest('.vg-card-outer') : null;
    if (card) card.classList.add('vg-card-outer--video-pending');
    try { vEl.load(); } catch (e) {}
  }

  function unloadPreviewVideo(vEl, force) {
    if (!vEl || vEl.dataset.mounted !== '1') return;
    var card = vEl.closest ? vEl.closest('.vg-card-outer') : null;
    /* Keep a captured first-frame only when we have no API thumbnail */
    if (
      !force &&
      card &&
      card.classList.contains('vg-card-outer--has-frame') &&
      !card.classList.contains('vg-card-outer--has-poster')
    ) {
      pausePreviewVideo(vEl);
      return;
    }
    try { vEl.pause(); } catch (e0) {}
    try {
      vEl.removeAttribute('src');
      vEl.load();
    } catch (e1) {}
    vEl.dataset.mounted = '0';
    if (card) {
      card.classList.remove('vg-card-outer--video-ready');
      card.classList.remove('vg-card-outer--has-frame');
    }
  }

  function mountPreviewVideo(vEl) {
    if (!vEl) return;
    var card = vEl.closest ? vEl.closest('.vg-card-outer') : null;
    var cardIdx = card ? parseInt(card.getAttribute('data-vg-index'), 10) : 0;
    if (isNaN(cardIdx)) cardIdx = 0;
    if (!mayLoadMp4At(cardIdx, cardIdx)) return;
    ensurePreviewSrc(vEl);
    function markReady() {
      if (card && !vEl.paused && vEl.readyState >= 2) {
        card.classList.add('vg-card-outer--video-ready');
        card.classList.add('vg-card-outer--has-frame');
        card.classList.remove('vg-card-outer--video-pending');
      }
      maybeUnlockMp4Batch();
    }
    function attemptPlay() {
      var playAttempt = vEl.play();
      if (playAttempt && typeof playAttempt.then === 'function') {
        playAttempt.then(markReady).catch(function () {});
      }
    }
    if (vEl.readyState >= 2) {
      attemptPlay();
      return;
    }
    function onCanPlay() {
      if (vEl.readyState < 2) return;
      vEl.removeEventListener('canplay', onCanPlay);
      vEl.removeEventListener('loadeddata', onCanPlay);
      attemptPlay();
    }
    vEl.addEventListener('canplay', onCanPlay);
    vEl.addEventListener('loadeddata', onCanPlay);
    attemptPlay();
  }

  function pausePreviewVideo(vEl) {
    if (!vEl || vEl.dataset.mounted !== '1') return;
    try { vEl.pause(); } catch (e) {}
  }

  /** Attach src so the first frame can paint, without forcing playback. */
  function warmPreviewFrame(vEl) {
    ensurePreviewSrc(vEl);
  }

  function cardHasApiPoster(card) {
    return !!(card && card.classList.contains('vg-card-outer--has-poster'));
  }

  function getNetworkConnection() {
    return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
  }

  function isCoarsePointerDevice() {
    try {
      return window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(hover: none)').matches;
    } catch (e0) {
      return false;
    }
  }

  function isGalleryNetworkFast() {
    var conn = getNetworkConnection();
    if (conn && conn.saveData) return false;
    var type = (conn && conn.effectiveType) || '';
    if (type === 'slow-2g') return false;
    return true;
  }

  /**
   * Rail MP4 window — video-first: play every in-view card; warm neighbours.
   */
  function getGalleryVideoWindow() {
    if (!isGalleryNetworkFast()) {
      return { playVisible: false, playCount: 1, warmAhead: 0, warmBehind: 0, keepRadius: 2 };
    }
    var warm = isCoarsePointerDevice() ? 1 : 3;
    return { playVisible: true, playCount: 6, warmAhead: warm, warmBehind: 1, keepRadius: isCoarsePointerDevice() ? 4 : 8 };
  }

  function setupRailLazy() {
    var mobileCardIo = null;

    function observeGalleryCardsForMobile() {
      if (!mobileCardIo || !root) return;
      var cards = root.querySelectorAll('.vg-card-outer[data-vg-index]');
      for (var oi = 0; oi < cards.length; oi++) {
        var card = cards[oi];
        if (card.getAttribute('data-vg-io') === '1') continue;
        card.setAttribute('data-vg-io', '1');
        mobileCardIo.observe(card);
      }
    }

    function setupMobileGalleryCardIo() {
      if (!isCoarsePointerDevice() || typeof IntersectionObserver === 'undefined') return;
      if (root.getAttribute('data-mobile-card-io') === '1') return;
      root.setAttribute('data-mobile-card-io', '1');
      mobileCardIo = new IntersectionObserver(
        function (entries) {
          if (!isGalleryNetworkFast()) return;
          for (var mi = 0; mi < entries.length; mi++) {
            var entry = entries[mi];
            var card = entry.target;
            var vEl = card.querySelector('video[data-lazy-video]');
            if (!vEl) continue;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.08) {
              var cardIdx = parseInt(card.getAttribute('data-vg-index'), 10);
              if (!isNaN(cardIdx) && mayLoadMp4At(cardIdx, cardIdx)) {
                card.setAttribute('data-vg-inview', '1');
                mountPreviewVideo(vEl);
              }
            } else if (!entry.isIntersecting || entry.intersectionRatio < 0.04) {
              card.removeAttribute('data-vg-inview');
              pausePreviewVideo(vEl);
            }
          }
        },
        { root: root, threshold: [0, 0.08, 0.2, 0.45, 0.7] }
      );
      observeGalleryCardsForMobile();
    }

    function cardLeftInRail(card) {
      if (card.parentElement === root) return card.offsetLeft;
      var x = 0;
      var node = card;
      while (node && node !== root) {
        x += node.offsetLeft;
        node = node.parentElement;
      }
      return x;
    }

    function cardInViewport(card, viewLeft, viewWidth) {
      var cLeft = cardLeftInRail(card);
      var cRight = cLeft + (card.offsetWidth || 0);
      return cRight > viewLeft + 8 && cLeft < viewLeft + viewWidth;
    }

    function syncRailVideos() {
      maybeAppendFromScroll();

      var cards = Array.prototype.slice.call(root.querySelectorAll('.vg-card-outer[data-vg-index]'));
      var viewLeft = root.scrollLeft;
      var viewWidth = root.clientWidth || root.offsetWidth || 0;
      if (viewWidth <= 0 || !cards.length) return;

      var win = getGalleryVideoWindow();
      var fastNetwork = isGalleryNetworkFast();
      var activeIdx = 0;
      var foundActive = false;
      var visibleIdx = {};
      for (var a = 0; a < cards.length; a++) {
        var c = cards[a];
        var idx = parseInt(c.getAttribute('data-vg-index'), 10);
        if (isNaN(idx)) idx = a;
        if (cardInViewport(c, viewLeft, viewWidth)) {
          visibleIdx[idx] = true;
          if (!foundActive) {
            activeIdx = idx;
            foundActive = true;
          }
        }
      }
      if (!foundActive) {
        var approx = estimateCardWidth() || 180;
        activeIdx = Math.max(0, Math.floor(viewLeft / approx));
      }

      if (!isDesktopModal()) {
        maybeLoadNextPhoneBatch(activeIdx);
        cards = Array.prototype.slice.call(root.querySelectorAll('.vg-card-outer[data-vg-index]'));
      }

      var warmEnd = activeIdx + win.warmAhead;
      var warmStart = Math.max(0, activeIdx - (win.warmBehind || 0));
      var visibleKeys = Object.keys(visibleIdx);
      var minVis = visibleKeys.length ? Math.min.apply(null, visibleKeys.map(function (k) { return parseInt(k, 10); })) : activeIdx;
      var maxVis = visibleKeys.length ? Math.max.apply(null, visibleKeys.map(function (k) { return parseInt(k, 10); })) : activeIdx;
      var keepRadius = win.keepRadius || 6;
      var keepStart = Math.max(0, minVis - keepRadius);
      var keepEnd = maxVis + keepRadius;

      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var index = parseInt(card.getAttribute('data-vg-index'), 10);
        if (isNaN(index)) index = i;
        var vEl = card.querySelector('video[data-lazy-video]');
        var inView = !!visibleIdx[index];

        /* Save-data / slow-2g: still play in-view video */
        if (!fastNetwork) {
          if (inView && mayLoadMp4At(index, activeIdx)) {
            card.setAttribute('data-vg-inview', '1');
            mountPreviewVideo(vEl);
          } else {
            card.removeAttribute('data-vg-inview');
            pausePreviewVideo(vEl);
          }
          continue;
        }

        if (win.playVisible && inView && mayLoadMp4At(index, activeIdx)) {
          card.setAttribute('data-vg-inview', '1');
          mountPreviewVideo(vEl);
          continue;
        }

        if (!win.playVisible && index === activeIdx && win.playCount > 0 && mayLoadMp4At(index, activeIdx)) {
          card.setAttribute('data-vg-inview', '1');
          mountPreviewVideo(vEl);
          continue;
        }

        if (index >= warmStart && index <= warmEnd && mayLoadMp4At(index, activeIdx)) {
          card.removeAttribute('data-vg-inview');
          warmPreviewFrame(vEl);
          pausePreviewVideo(vEl);
          continue;
        }

        if (index < keepStart || index > keepEnd) {
          card.removeAttribute('data-vg-inview');
          unloadPreviewVideo(vEl, true);
          continue;
        }

        card.removeAttribute('data-vg-inview');
        pausePreviewVideo(vEl);
      }
      maybeUnlockMp4Batch();
    }

    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        syncRailVideos();
      });
    }

    root.addEventListener('scroll', onScrollOrResize, { passive: true });
    if ('onscrollend' in window) {
      root.addEventListener('scrollend', syncRailVideos, { passive: true });
    }
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    /* Vertical page scroll: rail sync only ran on horizontal scroll before */
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    if (typeof IntersectionObserver !== 'undefined') {
      var railVisObs = new IntersectionObserver(
        function (entries) {
          for (var vi = 0; vi < entries.length; vi++) {
            if (entries[vi].isIntersecting) {
              onScrollOrResize();
              break;
            }
          }
        },
        { root: null, threshold: [0, 0.12, 0.35] }
      );
      railVisObs.observe(root);
      var railSection = root.closest('.video-gallery-section');
      if (railSection) railVisObs.observe(railSection);
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) onScrollOrResize();
    });
    document.addEventListener(
      'touchstart',
      function unlockGalleryAutoplay() {
        onScrollOrResize();
      },
      { once: true, passive: true }
    );
    var netConn = getNetworkConnection();
    if (netConn && typeof netConn.addEventListener === 'function') {
      netConn.addEventListener('change', onScrollOrResize);
    }
    setupMobileGalleryCardIo();
    railLazyApi = { refresh: syncRailVideos, appendNextPage: appendNextPage, observeCards: observeGalleryCardsForMobile };
    syncRailVideos();
    requestAnimationFrame(function () {
      requestAnimationFrame(syncRailVideos);
    });
    window.setTimeout(syncRailVideos, 400);
  }

  function bindModal() {
    if (!modal || modal.getAttribute('data-vg-modal-bound') === '1') return;
    modal.setAttribute('data-vg-modal-bound', '1');
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    if (overlay) overlay.addEventListener('click', closeModal);
    if (prevBtn) prevBtn.addEventListener('click', function () { openDesktopModalAt(modalIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { openDesktopModalAt(modalIndex + 1); });
    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        toggleGlobalMute();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (!modal || modal.style.display !== 'flex') return;
      if (e.key === 'Escape') closeModal();
      var modalLen = getModalList().length;
      if (isDesktopModal()) {
        if (e.key === 'ArrowLeft' && modalIndex > 0) openDesktopModalAt(modalIndex - 1);
        else if (e.key === 'ArrowRight' && modalIndex < modalLen - 1) openDesktopModalAt(modalIndex + 1);
      } else {
        if (e.key === 'ArrowDown' && modalIndex < modalLen - 1) {
          var next = feed && feed.querySelector('[data-slide-index="' + (modalIndex + 1) + '"]');
          if (next) focusFeedSlide(next, true);
        } else if (e.key === 'ArrowUp' && modalIndex > 0) {
          var prev = feed && feed.querySelector('[data-slide-index="' + (modalIndex - 1) + '"]');
          if (prev) focusFeedSlide(prev, true);
        }
      }
      if (e.key === ' ' || e.key === 'm' || e.key === 'M') {
        e.preventDefault();
        toggleGlobalMute();
      }
    });
  }

  async function init() {
    if (!API_URL) {
      hideGallerySection();
      return;
    }
    try {
      var data;
      if (window.WOMVideoFeed && typeof window.WOMVideoFeed.get === 'function') {
        data = await window.WOMVideoFeed.get(API_URL);
      } else {
        // Prefer the head-started fetch whenever it exists (homepage gallery shares
        // the same company videos endpoint started next to stories).
        var early = PRIORITY && PRIORITY.takeEarlyFetch
          ? PRIORITY.takeEarlyFetch('videos:gallery')
          : null;
        var canReuseEarly =
          early &&
          (DISPLAY_LOCATION === 'homepage' || DISPLAY_LOCATION === '') &&
          API_URL.indexOf('product_id=') === -1;
        if (canReuseEarly) {
          data = await early;
        } else {
          var apiUrl = API_URL + (API_URL.indexOf('?') === -1 ? '?' : '&') + '_ts=' + Date.now();
          var r = await fetch(apiUrl, { headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' }, cache: 'no-store' });
          if (!r.ok) throw new Error('API request failed: ' + r.status);
          data = await r.json();
        }
      }
      lastWomApiData = data;
      videoHandleIndex = buildVideoHandleIndex(data);
      var list = filterByLocation(normalizeFromWom(data));
      refillPlaylistHandles(list);
      if (window.WOMVideoGallery) {
        window.WOMVideoGallery._lastApiData = lastWomApiData;
        window.WOMVideoGallery._videoHandleIndex = videoHandleIndex;
      }
      if (FORCE_PRODUCT_HANDLE) {
        list = list.map(function (item) {
          if (!item) return item;
          item.productHandle = FORCE_PRODUCT_HANDLE;
          return item;
        });
      }
      // 0 / blank limit means show all homepage company videos
      if (LIMIT > 0) list = list.slice(0, LIMIT);
      if (!list.length) {
        hideGallerySection();
        return;
      }

      // Keep the full playlist in memory for the modal. First page in the rail:
      // 10 cards (desktop + phone); more only when the user scrolls near the end.
      playlist = list;
      renderedCount = 0;
      mp4BatchTier = 0;
      preloadGalleryThumbUrls(list, RAIL_EXPAND_TO_15);
      root.removeAttribute('data-wvg-loading');
      root.innerHTML = '';
      var firstTo = Math.min(list.length, getInitialPage());

      catalogReady = fetchCollectionCatalog();
      var productFetches = catalogReady.then(function () {
        return enrichCardRange(0, firstTo);
      });

      for (var i = 0; i < firstTo; i++) {
        root.appendChild(createCard(list[i], i));
      }
      renderedCount = firstTo;
      updateGridAlignment(renderedCount);
      if (modalAdd) bindAtc(modalAdd);
      markPriorityDone();
      setupRailLazy();
      bindModal();

      // Re-apply anything that resolved before the card nodes existed.
      productFetches.then(function () {
        for (var c = 0; c < renderedCount; c++) {
          if (playlist[c] && playlist[c].product) {
            var card = root.querySelector('.vg-card-outer[data-vg-index="' + c + '"]');
            if (card) applyProductToCard(card, playlist[c].product);
          }
        }
      });
      catalogReady.then(function () {
        for (var pi = 0; pi < playlist.length; pi++) {
          if (!playlist[pi].product && inferApiProductHandle(playlist[pi], lastWomApiData)) {
            ensureEntryProduct(pi);
          }
        }
      });
    } catch (e) {
      hideGallerySection();
    }
  }

  init();

  }

  function boot() {
    document.querySelectorAll('[data-video-gallery-root]').forEach(initVideoGallery);
  }

  // Run as soon as this script executes (section places it after the rail markup).
  // Also re-run on DOMContentLoaded for any roots injected later.
  boot();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();
